import templateUrl from 'emun.swatch/email-count-prompt.htm'
import controller from 'emun.swatch/email-count-prompt.controller'
import open from 'webmodals/open'

export default options => open(Object.assign({
    size: 'md',
    templateUrl,
    resolve: {
        options: () => options
    },
    bindToController: true,
    controller,
    controllerAs: '$ctrl'
}, (options || {}).modal)).result;